import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const CodeTagsNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M15.2997 17.3C14.9131 16.9134 14.9131 16.2866 15.2997 15.9L19.1997 12L15.2997 8.09998C14.9131 7.71338 14.9131 7.08658 15.2997 6.69998C15.6863 6.31338 16.3131 6.31338 16.6997 6.69998L20.5855 10.5858C21.3665 11.3668 21.3665 12.6331 20.5855 13.4142L16.6997 17.3C16.3131 17.6866 15.6863 17.6866 15.2997 17.3ZM8.6997 17.3C9.0863 16.9134 9.0863 16.2866 8.6997 15.9L4.7997 12L8.6997 8.09998C9.0863 7.71338 9.0863 7.08658 8.6997 6.69998C8.3131 6.31338 7.6863 6.31338 7.2997 6.69998L3.41391 10.5858C2.63286 11.3668 2.63286 12.6331 3.41391 13.4142L7.2997 17.3C7.6863 17.6866 8.3131 17.6866 8.6997 17.3Z'
            fill='currentColor'
        />
    </svg>
));
